'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

collapseDirective.$inject = ['$window'];


var _module = _angular2.default.module('cb.ui-components.collapse', []);

_module.directive('cbCollapse', collapseDirective);

exports.default = _module;


function collapseDirective($window) {
    var _toggleClass = 'is-open';
    var _groups = {};

    return {
        restrict: 'A',
        link: CollapseLink
    };

    function CollapseLink(scope, element, attr) {
        var selector = false;
        var group = false;
        var target = {
            element: element,
            collapseElement: false
        };

        // get collapse group cache
        if (_angular2.default.isDefined(attr.group) && attr.group.length > 0) {
            if (_angular2.default.isUndefined(_groups[attr.group])) {
                _groups[attr.group] = [];
            }

            group = _groups[attr.group];
            group.push(target);
        }

        if (_angular2.default.isDefined(attr.href) && attr.href.length > 0) {
            selector = attr.href;
        }

        if (_angular2.default.isDefined(attr.cbCollapse) && attr.cbCollapse.length > 0) {
            selector = attr.cbCollapse;
        }

        if (selector) {
            var nodes = $window.document.querySelectorAll(selector);
            if (nodes.length > 0) {
                target.collapseElement = _angular2.default.element(nodes[0]);
            }
        }

        if (target.collapseElement.hasClass(_toggleClass)) {
            target.element.addClass(_toggleClass);
        }

        element.on('click', function (event) {
            event.preventDefault();
            _toggleCollapse(target, group);
        });
    }

    function _toggleCollapse(target, group) {
        // if group only one group item can be active
        if (group) {
            if (!target.collapseElement.hasClass(_toggleClass)) {
                // already active, do nothing
                group.forEach(function (item) {
                    item.collapseElement.removeClass(_toggleClass);
                    item.element.removeClass(_toggleClass);
                });
                target.collapseElement.addClass(_toggleClass);
                target.element.addClass(_toggleClass);
            }
        } else {
            if (target.collapseElement.hasClass(_toggleClass)) {
                target.collapseElement.removeClass(_toggleClass);
                target.element.removeClass(_toggleClass);
            } else {
                target.collapseElement.addClass(_toggleClass);
                target.element.addClass(_toggleClass);
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-collapse.directive.js
// module id = 855
// module chunks = 0